export default __webpack_public_path__ + "static/img_7-5f8b45ee8828f928ab1527c5f74641cb.png";